import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { PermissionUser, PermissionUserStatus } from './permission-models';
import { Observable, ObservableLike, BehaviorSubject } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import * as _ from 'lodash';
import { CORE_CONFIG } from '../environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PermissionUserService {

  users = new BehaviorSubject<PermissionUser[]>([]);

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
    private authService: AuthService,
    @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/permissionuser`;
    this.getUsers({ status: PermissionUserStatus.Normal, pageSize: 1000 }).subscribe();
  }

  getUsers(params: { [param: string]: any }): Observable<AutoTablePageableResponse<PermissionUser>> {
    return this.httpClient.get<AutoTablePageableResponse<PermissionUser>>(`${this._baseURL}s`, {
      params: params
    }).pipe(
      tap(result => this.users.next(result.pageItems))
    );
  }

  getUser(username: string): Observable<PermissionUser> {
    return this.httpClient.get<PermissionUser>(`${this._baseURL}/${username}`);
  }

  newUser(username: string, name: string, email: string, password: string): Observable<any> {
    return this.httpClient.post(`${this._baseURL}`, { username, name, email, plainPassword: `${username}${password}` });
  }

  updateUser(username: string, name: string, email: string, status: PermissionUserStatus): Observable<any> {
    return this.httpClient.put(`${this._baseURL}/${username}`, { name, email, status });
  }

  removeUser(username: string[] | string): Observable<any> {
    if (_.isArray(username)) {
      return this.httpClient.delete(`${this._baseURL}`, {
        params: {
          username: username
        }
      });
    } else {
      return this.httpClient.delete(`${this._baseURL}/${username}`);
    }
  }

  recoverUser(username: string[] | string): Observable<any> {
    if (_.isArray(username)) {
      return this.httpClient.patch(`${this._baseURL}`, {}, {
        params: {
          username: username,
          status: PermissionUserStatus.Normal
        }
      });
    } else {
      return this.httpClient.patch(`${this._baseURL}/${username}`, {}, {
        params: {
          status: PermissionUserStatus.Normal
        }
      });
    }
  }

  resetPassword(username: string): Observable<PermissionUser> {
    return this.httpClient.patch<PermissionUser>(`${this._baseURL}/${username}`, {}, {
      params: {
        resetpwd: 'true'
      }
    });
  }

  grantRoleToUser(rolename: string, username: string): Observable<any> {
    return this.httpClient.post(`${this._baseURL}/${username}/role/${rolename}`, {});
  }

  revokeRoleToUser(rolename: string, username: string): Observable<any> {
    return this.httpClient.delete(`${this._baseURL}/${username}/role/${rolename}`);
  }

}
